
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/catalog/category/[id]",
      function () {
        return require("private-next-pages/catalog/category/[id].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/catalog/category/[id]"])
      });
    }
  